import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const mediaUrl = (u) => (!u ? "" : u.startsWith("/") ? `${BACKEND_URL}${u}` : u);

export const catPath = (slug) => (slug === "chronique" ? "/chronique" : `/rubrique/${slug}`);

export const formatDate = (iso, opts) =>
  iso ? new Date(iso).toLocaleDateString("fr-FR", opts || { day: "numeric", month: "short", year: "numeric" }) : "";

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};
